// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'

const clearAntennaValues = sourceForm => (dispatch, getState) => {
  const initialValues = {
    antennaCode: '',
    modelNumber: '',
    classificationId: null,
    companyName: '',
    diameter: '',
    diameterUnit: 'SI',
    pagination: null,
  }

  dispatch(initialize(sourceForm, initialValues))
}

export default clearAntennaValues
